import React from 'react';
import { MdTurnLeft, MdAddCircleOutline } from "react-icons/md";

const ActionButtons = ({ 
  handleFormCancel, 
  handleFormSubmit, 
  invalidLines
}) => {
  return (
    <div
      style={{
        textAlign: "right",
        display: "flex",
        gap: "1rem",
        justifyContent: "flex-end",
      }}
    >
      <button
        type="button"
        onClick={handleFormCancel}
        className="back-button"
      >
        <MdTurnLeft size={28} />&nbsp;&nbsp;Voltar
      </button>
      <button
        type="submit"
        disabled={invalidLines()}
        className="submit-button"
        onClick={handleFormSubmit}
      >
        <MdAddCircleOutline size={28} />&nbsp;&nbsp;Submeter Documento
      </button>
    </div>
  );
};

// Componente separado para o botão de adicionar item
export const AddItemButton = ({ addFunction, invalidLines, shouldShowAddItemButton, lines }) => {
  if (!shouldShowAddItemButton) return null;
  
  // O botão "Adicionar Item" deve estar sempre habilitado quando visível
  // Ele não deve ser desabilitado por invalidLines() pois é usado para criar linhas
  const isDisabled = false;
  
  return (
    <div style={{ textAlign: "right", marginBottom: "1rem" }}>
      <button
        type="button"
        onClick={addFunction}
        disabled={isDisabled}
        className="add-product-button"
        title="Adicionar item"
      >
        <MdAddCircleOutline size={24} />
        Adicionar Item
      </button>
    </div>
  );
};

export default ActionButtons;
